<a [href]="link()">
    <img
            class="app-store-button"
            [src]="imageUrl()"
            alt="App store button"
    />
</a>